import { useNavigate } from "react-router-dom"
import { navigateToEmployeeDetails } from "utils/navigator"

// Person name in the HR report tables; opens the employee's page when the id is known
const EmployeeLink = ({ id, name }: { id: string | null | undefined, name: string | null | undefined }) => {
    const navigate = useNavigate()
    if (!name) return <>-</>
    if (!id) return <>{name}</>

    return <a className="table-link" role="button" onClick={() => navigateToEmployeeDetails(navigate, id)}>
        {name}
    </a>
}

export default EmployeeLink
